import React from 'react';

const Hero = () => {
  return (
    <section id="hero" className="relative min-h-screen flex flex-col justify-center md:items-center overflow-hidden pt-32 md:pt-0">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.youware.com/users-website-assets/prod/42806107-9efa-4743-9602-d260f74d9046/f5154659bd8a4a1d9bbbcb85a602c985.jpg"
          alt="Grand Piano in Concert Hall"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>
      {/* Content */}
      <div className="relative z-10 text-center text-white px-4 max-w-5xl mx-auto pb-16 md:pb-0">
        <div className="mb-6 inline-block border-b-2 border-yellow-500 pb-2">
          <span className="text-lg md:text-xl tracking-[0.2em] uppercase">The 2nd Intercollegiate Piano Team Contest</span>
        </div>
        
        <h1
          className="text-4xl md:text-6xl lg:text-7xl font-bold mb-8 leading-tight tracking-wide"
          style={{
            fontSize: "clamp(32px, 5vw, 64px)" // モバイル対応のためにclampを使用
          }}>
          <span className="block text-2xl md:text-3xl mb-4 font-normal">第2回</span>
          大学対抗<br className="md:hidden" />ピアノ演奏<br className="md:hidden" />チームコンテスト
        </h1>

        <p className="text-xl md:text-2xl mb-12 font-light tracking-wider text-gray-200">
          仲間と奏でる、最高のハーモニー
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-12 mb-12 bg-white/10 backdrop-blur-sm p-6 rounded-lg border border-white/20">
          <div className="text-center">
            <p className="text-sm text-gray-300 mb-1 uppercase tracking-widest">Date</p>
            <p className="text-2xl md:text-3xl font-semibold">2026.8.29<span className="text-lg ml-1">(土)</span></p>
            <p className="text-sm md:text-base mt-1">13:00 - 17:00</p>
          </div>
          <div className="hidden md:block w-px h-16 bg-white/30"></div>
          <div className="text-center">
            <p className="text-sm text-gray-300 mb-1 uppercase tracking-widest">Venue</p>
            <p className="text-xl md:text-2xl font-semibold">東京芸術センター21階</p>
            <p className="text-lg md:text-xl mt-1">天空劇場</p>
          </div>
        </div>

        <a
          href="#contact"
          className="inline-block bg-yellow-600 text-white px-10 py-4 rounded-full text-lg font-bold hover:bg-yellow-500 transition-all transform hover:scale-105 shadow-lg hover:shadow-xl tracking-widest"
        >
          エントリー・詳細はこちら
        </a>
      </div>
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce hidden md:block">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center pt-2">
          <div className="w-1 h-2 bg-white rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
